module.exports = "/images/almi_logo.svg?c576ef5745aa2681e4ed200235b35d9d";